import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FactoryIcon, RulerIcon, BanknoteIcon, CarIcon, TruckIcon, ZapIcon, ShieldCheckIcon, WrenchIcon, HomeIcon, MapPinIcon, KeyIcon, ConstructionIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ParametersSection() {
  return <section id="parametry" className="py-24 bg-slate-50 border-y border-slate-200" data-id="element-208">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
        <div className="text-center mb-16" data-id="element-210">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-slate-900" data-id="element-211">
            Parametry objektu
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '60px'
        }} viewport={{
          once: true
        }} className="h-1 bg-slate-700 mx-auto mt-6" data-id="element-212" />
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-213">
          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-214">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-215">
              <FactoryIcon className="w-6 h-6" data-id="element-216" />
            </div>
            <div data-id="element-217">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-218">
                Typ objektu
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-219">
                Výrobní haly, sklady, kanceláře, dílny
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-220">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-221">
              <RulerIcon className="w-6 h-6" data-id="element-222" />
            </div>
            <div data-id="element-223">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-224">
                Celková plocha
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-225">
                7 500 m² (vnitřní 3 000 m² + venkovní 5 000 m²)
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-226">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-227">
              <BanknoteIcon className="w-6 h-6" data-id="element-228" />
            </div>
            <div data-id="element-229">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-230">
                Cena
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-231">
                od 10 000 Kč/měsíc (5 Kč/m²)
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-232">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-233">
              <CarIcon className="w-6 h-6" data-id="element-234" />
            </div>
            <div data-id="element-235">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-236">
                Parkování
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-237">
                100 parkovacích stání, 10 garáží
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-238">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-239">
              <TruckIcon className="w-6 h-6" data-id="element-240" />
            </div>
            <div data-id="element-241">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-242">
                Příjezd
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-243">
                Nakládací rampy, zpevněné plochy, vjezd pro kamiony
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-244">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-245">
              <ZapIcon className="w-6 h-6" data-id="element-246" />
            </div>
            <div data-id="element-247">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-248">
                Energie
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-249">
                230V, 380V, 400V, 3 fáze, jistič 63A
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-250">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-251">
              <ShieldCheckIcon className="w-6 h-6" data-id="element-252" />
            </div>
            <div data-id="element-253">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-254">
                Zabezpečení
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-255">
                Kamerový systém, hlídací služba, alarm
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-256">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-257">
              <WrenchIcon className="w-6 h-6" data-id="element-258" />
            </div>
            <div data-id="element-259">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-260">
                Vybavení
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-261">
                Portálové jeřáby, servisní jámy, dílny
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-262">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-263">
              <HomeIcon className="w-6 h-6" data-id="element-264" />
            </div>
            <div data-id="element-265">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-266">
                Možnosti využití
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-267">
                Autoservis, garáže, úložiště veteránů, lodí, karavanů
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-268">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-269">
              <MapPinIcon className="w-6 h-6" data-id="element-270" />
            </div>
            <div data-id="element-271">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-272">
                Lokalita
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-273">
                Centrum Žlutic, Karlovarský kraj
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-274">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-275">
              <KeyIcon className="w-6 h-6" data-id="element-276" />
            </div>
            <div data-id="element-277">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-278">
                Dostupnost
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-279">Ihned k nastěhování</p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-280">
            <div className="flex-shrink-0 p-3 bg-slate-100 rounded-sm text-slate-600" data-id="element-281">
              <ConstructionIcon className="w-6 h-6" data-id="element-282" />
            </div>
            <div data-id="element-283">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-284">
                Stav
              </h3>
              <p className="text-slate-900 font-medium" data-id="element-285">
                Probíhá revitalizace, možnost úprav dle přání
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}